<template>
  <div class="fullEditor">
    <div class="mx-4 mb-3 d-flex">
      <div class="step_number_circle"><span>2</span></div> Please Copy and Paste the information from the
      <a class="fw-600 text-main mx-1" href="https://travcorp.sharepoint.com/:x:/s/Global/Teams/Groups/EbxB4dc3_3VIk3SINOdmLgoBPL7FA5VMdMoRB2MHIpTS5Q?e=4UhPDy" target="_blank">template of Hotel List</a>
      to be added into the Guest Documentation
      <BaseLabelWithPopover width="150px">
          <h6>Template of Hotel List</h6>
        </BaseLabelWithPopover>
    </div>
    <Editor
      v-model="$v[validationGroupName].guestDocumentation.hotelList.$model"
      @blur="$v[validationGroupName].guestDocumentation.hotelList.$touch()"
      :validator="$v[validationGroupName].guestDocumentation.hotelList"
      :showDebugger="false"
      :disabled="isCompletedQuote" />
  </div>
</template>

<script>
import Editor from '@/components/_shared/Editor.vue'

export default {
  name: 'TabHotelList',
  inject: ['$v'],
  components: { Editor },
  props: {
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    }
  }
}
</script>
